<template>
  <div class="tw-flex tw-items-center">
    <component
      :is="iconComponent"
      :id="`popover-${type}-${checklistItemId}`"
      :class="[
        'info-icon',
        type,
        value ? colorStyle[value] : 'tw-text-[#DBDBDB]',
        isMaster ? 'tw-text-[#666666]' : '',
        classIcon,
      ]"
    />
    <AssessmentIconTooltip
      :id="`popover-${type}-${checklistItemId}`"
      :text="`${label} - ${computedLabel}`"
      class="!tw-top-[-22px]"
    />
  </div>
</template>

<script setup lang="ts">
import AssessmentIconTooltip from "./assessmentIconTooltip.vue";

defineProps<{
  type: "importance" | "impact" | "cost" | "effort" | "score";
  iconComponent: any;
  value?: string | null;
  label: string;
  checklistItemId: string | number;
  isMaster?: boolean;
  computedLabel?: string | number;
  colorStyle: object;
  classIcon?: string;
}>();
</script>
<style scoped>
.info-icon {
  outline: none;
  margin-left: 0px;
}
</style>
